import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const licenseService = {
    getAllLicenses,
    getLicenseById,
    getSystemsByLicenseId,
    getNotLinkedSystems,
    getAllFiltersOptions,
    connectSystems,
    createLicense,
    updateLicense,
    deleteLicense,
    checkUnicity,
    connectLicenses,
    disconnectLicense,
};

const { apiUrl, apiVer } = defineConfig.LICENSES_SERVICE;

function getApiPath(){
  return (apiUrl + apiVer + "/system/license");
}

function getAllLicenses(category = "GRANT", searchFilters = {}, page = 0, perPage = 10) {
  let filters = searchFilters.filters;
  let sorter = searchFilters.sorter || {field: "createdAt", order: "descend"};
  let sortType = "DESC";

  let queryParams = [];

  for (const key in filters) {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      if (Array.isArray(filters[key])) {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key].join(","))}`);
      } else {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`);
      }
    }
  }

  if(sorter && sorter.field) {
    if (sorter.field && sorter.order) {
      sortType = sorter.order === 'descend' ? 'DESC' : 'ASC';
    }
  } else {
    sorter.field = "createdAt";
  }

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
  const url = getApiPath() + "/all/" + category + "/" + page + "/" + perPage + "/" + sorter.field + "/" + sortType + queryString;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getLicenseById(category, id) {
    const url = getApiPath() + "/read/" + category + "/" + id;
  
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      });
}

function getSystemsByLicenseId(category, id) {
    const url = getApiPath() + "/all/" + category + "/system/" + id;
  
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      });
}

function getNotLinkedSystems(category = "GRANT", searchFilters = {}, page = 0, perPage = 10) {
  let filters = searchFilters.filters;
  let sorter = searchFilters.sorter || {field: "creationDate", order: "ascend"};
  let sortType = "ASC";

  let queryParams = [];

  for (const key in filters) {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      if (Array.isArray(filters[key])) {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key].join(","))}`);
      } else {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`);
      }
    }
  }

  if(sorter && sorter.field) {
    if (sorter.field && sorter.order) {
      sortType = sorter.order === 'descend' ? 'DESC' : 'ASC';
    }
  } else {
    sorter.field = "creationDate";
  }

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
  const url = getApiPath() + "/all/" + category + "/system/" + page + "/" + perPage + "/" + sorter.field + "/" + sortType + queryString;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllFiltersOptions(category, field) {
  const url = getApiPath() + "/all/" + category + "/filter/" + field;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function connectSystems(category, body) {
  const url = getApiPath() + "/create/" + category + "/connect";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createLicense(category, values) {
  const url = getApiPath() + "/create/" + category;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(values)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateLicense(category, values) {
  const url = getApiPath() + "/update/" + category;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(values)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteLicense(category, id) {
    const url = getApiPath()  + "/delete/" + category + "/" + id
  
    const requestOptions = {
      method: "DELETE",
      headers: authHeader("application/json"),
    };
  
    return fetch(
      url,
      requestOptions
    )
      .then(handleResponse)
      .then(res => {
        return res;
      });
}

function checkUnicity(category, field, value) {
  const url = getApiPath() + "/read/" + category + "/unicity/" + field + "/" + value; 
  
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function connectLicenses(body) {
  const url = getApiPath() + "/create/" + body.category + "/connect/" + body.systemId + "?accountNumber=" + (body.accountNumber ? body.accountNumber : "");
  
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body.licenseIds)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function disconnectLicense(category, licenseId, systemId) {
  const url = getApiPath() + "/update/" + category + "/disconnect/" + licenseId + "/" + systemId;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}